// Copyright (c) 2022 Proto Labs, Inc. All Rights Reserved.
import { LinkLanguage } from "./models";

class FieldLengthValue {
    min: number;
    max: number;

    constructor(min: number, max: number) {
        this.min = min;
        this.max = max;
    }
}

export const FieldLengths = Object.freeze({
    Email: new FieldLengthValue(0, 100),
    Name: new FieldLengthValue(0, 128),
    Phone: new FieldLengthValue(0, 30),
    CompanyName: new FieldLengthValue(0, 80),
    Password: new FieldLengthValue(12, 100),
    Street: new FieldLengthValue(0, 128),
    City: new FieldLengthValue(0, 48),
    StateProvince: new FieldLengthValue(0, 64),
    PostalCode: new FieldLengthValue(0, 10),
});

const Languages = Object.freeze({
    enUS: 'en-US',
    enGB: 'en-GB',
    enIE: 'en-IE',
    enMT: 'en-MT',
    enNL: 'en-NL',
    esES: 'en-ES',
    deDE: 'de-DE',
    frFR: 'fr-FR',
    frBE: 'fr-BE',
    frCH: 'fr-CH',
    frGB: 'fr-GB',
    itIT: 'it-IT',
    plPL: 'pl-PL',
    de: 'de',
    it: 'it',
    pl: 'pl'
});

export const LinkLanguages = Object.freeze(
    [
        new LinkLanguage({hrefLang: Languages.enUS, queryStringLang: Languages.enUS}),
        new LinkLanguage({hrefLang: Languages.enGB, queryStringLang: Languages.enGB}),
        new LinkLanguage({hrefLang: Languages.enIE, queryStringLang: Languages.enGB}),
        new LinkLanguage({hrefLang: Languages.enMT, queryStringLang: Languages.enGB}),
        new LinkLanguage({hrefLang: Languages.enNL, queryStringLang: Languages.enGB}),
        new LinkLanguage({hrefLang: Languages.esES, queryStringLang: Languages.esES}),
        new LinkLanguage({hrefLang: Languages.de, queryStringLang: Languages.deDE}),
        new LinkLanguage({hrefLang: Languages.frFR, queryStringLang: Languages.frFR}),
        new LinkLanguage({hrefLang: Languages.frBE, queryStringLang: Languages.frFR}),
        new LinkLanguage({hrefLang: Languages.frCH, queryStringLang: Languages.frFR}),
        new LinkLanguage({hrefLang: Languages.frGB, queryStringLang: Languages.frFR}),
        new LinkLanguage({hrefLang: Languages.it, queryStringLang: Languages.itIT}),
        new LinkLanguage({hrefLang: Languages.pl, queryStringLang: Languages.plPL}),
    ]
);

export default {
    FieldLengths,
    LinkLanguages,
};
